<template>
    <div class="snippet-preview-wrapper">
        <!-- [D20] Chat panel + border (SnippedPanelBorderColor) -->
        <div class="dialog-card" :style="[panelBorderStyle, { height: resolvedPanelHeightCss }]">
            <!-- Header with gradient using SnippedHeaderColorTheme -->
            <div class="dialog-header" :style="dialogHeaderStyle">
                <div class="d-flex align-center dialog-header-left">
                    <img :src="SnippedLogo || logoRemovebg" alt="logo" class="dialog-logo" :style="{ background: SnippedLogo ? '#fff' : 'transparent' }">
                    <div v-if="showBotNameResolved || showsHeaderSubtitle" class="dialog-header-text">
                        <div v-if="showBotNameResolved" class="dialog-bot-name">{{ botName || 'Chatbot' }}</div>
                        <div v-if="showsHeaderSubtitle" class="dialog-bot-subtitle">{{ SnippedHeaderSubtitle }}</div>
                    </div>
                </div>
                <div class="d-flex align-center">
                    <v-btn icon size="small" variant="text" :style="{ color: '#FFFFFF', height: '30px', width: '30px' }">
                        <v-icon>mdi-magnify-plus-outline</v-icon>
                    </v-btn>
                    <v-btn icon size="small" variant="text" :style="{ color: '#FFFFFF', height: '30px', width: '30px' }">
                        <v-icon>mdi-window-minimize</v-icon>
                    </v-btn>
                </div>
            </div>

            <!-- Sub-header with white background -->
            <!-- [D3] SnippedShowModelTopicBar=false ซ่อนเฉพาะ label Model/Topic · ปุ่ม Login อยู่ที่เดิม (ตรงกับ Snippet.vue) -->
            <div class="dialog-subheader">
                <span v-if="showModelTopicBarResolved" :style="{ fontSize: '10px', fontWeight: 500, color: '#000000' }">Model 1 (Azure GPT 4o)</span>
                <span v-else></span>
                <v-btn variant="outlined" size="small" class="login-gradient-btn" :style="{ '--login-grad': loginGradient }">
                    Login
                </v-btn>
            </div>

            <!-- Chat conversation area -->
            <div class="dialog-chat-area">
                <!-- User message -->
                <div class="d-flex justify-end align-center mb-2">
                    <span class="mr-2" style="font-size: 8px; color: #71717A;">22 Oct, 10:32 AM</span>
                    <div class="user-message" :style="userMessageStyle">Hello</div>
                </div>

                <!-- Bot response (avatar from SnippedIcon / SnippedIconColor) -->
                <div class="d-flex justify-start align-start mb-2 bot-preview-row">
                    <div v-if="showSnippedIconResolved" class="bot-preview-avatar-shell">
                        <img v-if="shouldUseSnippedAvatarImage" :src="resolvedSnippedIconImage" alt="Bot" class="bot-preview-avatar">
                        <v-icon v-else size="18" :style="{ color: resolvedSnippedIconColor }">{{ resolvedSnippedIconName }}</v-icon>
                    </div>
                    <div class="bot-preview-content">
                        <div class="gpt-message" :style="botMessageStyle">Hi! How can I help you today?</div>
                        <span class="bot-preview-time">22 Oct, 10:32 AM</span>
                    </div>
                </div>

                <!-- Another user message -->
                <div class="d-flex justify-end align-center mb-2">
                    <span class="mr-2" style="font-size: 8px; color: #71717A;">22 Oct, 10:33 AM</span>
                    <div class="user-message" :style="userMessageStyle">I need help with my account settings</div>
                </div>

                <!-- Typing indicator: แสดงตลอดใน preview เพื่อให้ admin เห็นผลของ SnippedTypingText (ของจริงโชว์เฉพาะตอนบอทกำลังคิด) -->
                <div class="d-flex justify-start align-center bot-preview-row">
                    <div v-if="showSnippedIconResolved" class="bot-preview-avatar-shell">
                        <img v-if="shouldUseSnippedAvatarImage" :src="resolvedSnippedIconImage" alt="Bot" class="bot-preview-avatar">
                        <v-icon v-else size="18" :style="{ color: resolvedSnippedIconColor }">{{ resolvedSnippedIconName }}</v-icon>
                    </div>
                    <div class="bot-preview-typing">
                        <span class="bot-preview-typing-text">{{ SnippedTypingText || 'Thinking of a response' }}</span>
                        <span class="bot-preview-typing-dots">···</span>
                    </div>
                </div>
            </div>

            <!-- Message input area (SnippedInputPlaceholder) + disclaimer (SnippedDisclaimerText) -->
            <!-- Message input — โครง mirror .chat-input-container ของ Snippet.vue: textarea กับปุ่ม send เป็น flex sibling
                 และเส้นขอบ/เงาอยู่ที่ container ไม่ใช่ outline ของ field (ไม่งั้นได้เส้น 2 ชั้น) ย่อสเกลให้เข้ากับ preview -->
            <div class="dialog-footer">
                <div class="preview-composer">
                    <v-textarea
                        :placeholder="SnippedInputPlaceholder || 'Type your message here...'"
                        class="dialog_text_area"
                        variant="outlined"
                        density="comfortable"
                        bg-color="surface"
                        rounded="lg"
                        rows="1"
                        max-rows="3"
                        auto-grow
                        no-resize
                        hide-details
                    ></v-textarea>
                    <!-- ปุ่ม send — สี/สไตล์ตาม /ServiceTheme · ลูกศร recolor ผ่าน mask
                         ของจริงซ่อนปุ่มตอนยังไม่พิมพ์ · preview โชว์ตลอดเพื่อให้เห็นผลของ Button Style -->
                    <div class="preview-send-actions">
                        <span class="preview-send-btn" :style="sendButtonSurfaceStyle">
                            <span class="preview-send-glyph" :style="sendGlyphStyle"></span>
                        </span>
                    </div>
                </div>
                <!-- [version | counter] แล้วค่อย disclaimer — ลำดับเดียวกับ Snippet.vue จริง -->
                <div class="d-flex justify-space-between align-center mt-1" style="font-size: 8px; color: #71717a;">
                    <span v-if="showVersionResolved">Version R{{ versioning }}</span>
                    <span v-else></span>
                    <span v-if="showCharCounterResolved">0/200000</span>
                    <span v-else></span>
                </div>
                <div v-if="hasDisclaimerText" class="dialog-disclaimer">{{ SnippedDisclaimerText }}</div>
            </div>
        </div>

        <!-- [S1-P2] ความสูงกล่องเป็นสัดส่วนจริงแต่ถูก clamp ด้วยกรอบ preview — hint บอกค่าที่ตั้งจริง -->
        <div class="snippet-launcher-hint" data-testid="snipped-panel-height-preview-hint">{{ panelHeightPreviewHint }}</div>

        <!-- [D19] teaser bubble — ข้อความจริงมาจาก greeting (/SetupSocial) preview จึงโชว์ตัวอย่าง -->
        <div v-if="teaserEnabledResolved" class="snippet-teaser-preview">
            <div class="snippet-teaser-bubble" :style="{ background: teaserBubbleBackground, color: teaserBubbleForeground }">
                <button type="button" class="snippet-teaser-close" aria-label="ปิด">&times;</button>
                <span class="snippet-teaser-text">ข้อความทักทายจาก /SetupSocial</span>
            </div>
        </div>

        <!-- Launcher preview (circle / pill) — [D6] pill fallback = circle เมื่อ SnippedLauncherText ว่าง/whitespace -->
        <div class="snippet-launcher-preview">
            <div v-if="isPill" class="snippet-launcher-pill" :style="launcherSurfaceStyle">
                <span v-if="showLauncherIconResolved" class="snippet-launcher-pill-icon">
                    <img v-if="shouldUseLauncherIconImage" :src="resolvedLauncherIconImage" alt="launcher" class="snippet-launcher-icon-img">
                    <v-icon v-else size="16" :color="launcherForeground">{{ resolvedLauncherIconName }}</v-icon>
                </span>
                <span class="snippet-launcher-pill-text">{{ SnippedLauncherText }}</span>
            </div>
            <!-- circle มีแต่ไอคอน — ปิดไอคอนแล้วยังต้องเห็นปุ่ม จึงคงไอคอนไว้เสมอในโหมดนี้
                 circle + รูปที่อัปโหลด = รูปเต็มปุ่ม ไม่มีพื้น/เส้นขอบ (คงเงาไว้) — ต้องตรงกับ ChatFrameworkSnippet.js -->
            <div v-else class="snippet-launcher-circle" :class="{ 'snippet-launcher-circle--image': isLauncherImageFull }" :style="launcherSurfaceStyle">
                <img v-if="shouldUseLauncherIconImage" :src="resolvedLauncherIconImage" alt="launcher"
                    class="snippet-launcher-icon-img" :class="{ 'snippet-launcher-icon-img--full': isLauncherImageFull }">
                <v-icon v-else size="24" :color="launcherForeground">{{ resolvedLauncherIconName }}</v-icon>
            </div>
        </div>

        <!-- Position/Offset มีผลบนเว็บจริงเท่านั้น — preview วาง launcher ที่มุมล่างคงที่ -->
        <div class="snippet-launcher-hint">{{ launcherPositionHint }}</div>
    </div>
</template>

<script>
import logoRemovebg from '@/assets/images/logo-removebg-preview@3x.png';
import { version } from '../../package.json';

/*
 * SnippedPreview.vue — live preview (client-side only, no API call).
 *
 * Prop contract for the parent (ConfigTheme.vue / Task T5) — bind case-exact PascalCase
 * (e.g. :SnippedLauncherShape="ConfigData.SnippedLauncherShape"). These mirror the API
 * `Snipped*` field names 1:1.
 *
 *   Base / existing:
 *     SnippedLogo, SnippedColorThemeChat, SnippedIcon (mdi name OR blob/url — img derived
 *     via URL-like check), SnippedIconColor, SnippedHeaderColorTheme, SnippedFontColorTheme
 *   Launcher (9 + position/offset):
 *     SnippedLauncherShape, SnippedLauncherVariant, SnippedLauncherText, SnippedLauncherTextColor,
 *     SnippedLauncherBgColor, SnippedLauncherIcon (mdi name OR blob url), IsImgSnippedLauncherIcon,
 *     SnippedLauncherPosition, SnippedLauncherOffsetX, SnippedLauncherOffsetY (last three = hint only,
 *     preview draws launcher at a fixed bottom corner — real position/offset apply on the live widget)
 *   Teaser (3):
 *     SnippedTeaserEnabled (teaser shows only when true), SnippedTeaserBgColor, SnippedTeaserTextColor
 *   Panel (7):
 *     SnippedHeaderSubtitle, SnippedDisclaimerText, SnippedPanelBorderColor, SnippedInputPlaceholder,
 *     SnippedTypingText, SnippedShowBotName, SnippedShowModelTopicBar (default-on: show unless === false)
 *   Panel height (2 — S1-P2):
 *     SnippedPanelHeightMode ('default' | 'full' | 'custom'; null/other = default 400px),
 *     SnippedPanelHeight (px 300–1000, read only when mode === 'custom'; number or numeric string)
 *   Auxiliary (NOT a theme field): botName (actual bot display name, optional)
 *
 * Nullable bool props (SnippedTeaserEnabled / SnippedShowBotName / SnippedShowModelTopicBar /
 * IsImgSnippedLauncherIcon) come from the API as bool? — pass real booleans (or leave undefined);
 * the component treats null/undefined as the default (off, except ShowModelTopicBar = on).
 * All colors run through normalizeHexColor(#RRGGBB) with a fallback, so partial/invalid hex
 * never breaks the preview. Launcher/bot images use blob/url strings (no base64).
 */
export default {
    props: {
        // ── Base / existing ──
        SnippedLogo: {
            type: String,
            required: false,
            default: ''
        },
        SnippedColorThemeChat: {
            type: String,
            required: false,
            default: '#C32E0E'
        },
        SnippedHeaderColorTheme: {
            type: String,
            required: false,
            default: '#C32E0E'
        },
        SnippedFontColorTheme: {
            type: String,
            required: false,
            default: '#FFFFFF'
        },
        // Bot avatar icon — single field holding mdi name OR blob/url (img derived via URL-like check)
        SnippedIcon: {
            type: String,
            required: false,
            default: 'mdi-robot-outline'
        },
        SnippedIconColor: {
            type: String,
            required: false,
            default: '#000000'
        },
        // ── Launcher ──
        SnippedLauncherShape: {
            type: String,
            required: false,
            default: 'circle'
        },
        // [D17] 'default' | 'secondary' | 'outline' — determines surface/border/foreground
        SnippedLauncherVariant: {
            type: String,
            required: false,
            default: 'default'
        },
        SnippedLauncherText: {
            type: String,
            required: false,
            default: ''
        },
        SnippedLauncherTextColor: {
            type: String,
            required: false,
            default: '#FFFFFF'
        },
        SnippedLauncherBgColor: {
            type: String,
            required: false,
            default: ''
        },
        // Launcher icon — single field holding mdi name OR blob url; img mode driven by IsImgSnippedLauncherIcon
        SnippedLauncherIcon: {
            type: String,
            required: false,
            default: ''
        },
        IsImgSnippedLauncherIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        // Hint-only (real placement happens on the live widget)
        SnippedLauncherPosition: {
            type: String,
            required: false,
            default: 'bottom-right'
        },
        SnippedLauncherOffsetX: {
            type: [Number, String],
            required: false,
            default: null
        },
        SnippedLauncherOffsetY: {
            type: [Number, String],
            required: false,
            default: null
        },
        // ── Teaser ──
        SnippedTeaserEnabled: {
            type: Boolean,
            required: false,
            default: false
        },
        SnippedTeaserBgColor: {
            type: String,
            required: false,
            default: ''
        },
        SnippedTeaserTextColor: {
            type: String,
            required: false,
            default: ''
        },
        // ── Panel ──
        SnippedHeaderSubtitle: {
            type: String,
            required: false,
            default: ''
        },
        SnippedDisclaimerText: {
            type: String,
            required: false,
            default: ''
        },
        // [D20] panel border · ว่าง = ไม่มีขอบ
        SnippedPanelBorderColor: {
            type: String,
            required: false,
            default: ''
        },
        SnippedInputPlaceholder: {
            type: String,
            required: false,
            default: ''
        },
        // ข้อความตอนบอทกำลังคิด · ว่าง = fallback 'Thinking of a response' (ตรงกับ Snippet.vue)
        SnippedTypingText: {
            type: String,
            required: false,
            default: ''
        },
        SnippedShowBotName: {
            type: Boolean,
            required: false,
            default: false
        },
        // [D3] default true — ตรงกับ Snippet.vue ที่เช็ค `!== false` (null/undefined = แสดงแถบ)
        SnippedShowModelTopicBar: {
            type: Boolean,
            required: false,
            default: true
        },
        // ── R2: display settings ──
        // Bot bubble uses the same 10% background / 20% border alpha treatment as the user bubble.
        SnippedBotBubbleColor: {
            type: String,
            required: false,
            default: '#71717A'
        },
        SnippedBotFontColor: {
            type: String,
            required: false,
            default: '#71717A'
        },
        // ว่าง = ใช้สีจาก SnippedColorThemeChat
        SnippedSendButtonColor: {
            type: String,
            required: false,
            default: ''
        },
        // 'default' | 'secondary' | 'outline' — same treatment as the launcher variant
        SnippedSendButtonVariant: {
            type: String,
            required: false,
            default: 'default'
        },
        // ทุกตัวด้านล่าง default true — ตรงกับ Snippet.vue ที่เช็ค `!== false` (null/undefined = แสดง)
        SnippedShowHeaderSubtitle: {
            type: Boolean,
            required: false,
            default: true
        },
        SnippedShowVersion: {
            type: Boolean,
            required: false,
            default: true
        },
        SnippedShowCharCounter: {
            type: Boolean,
            required: false,
            default: true
        },
        SnippedShowSnippedIcon: {
            type: Boolean,
            required: false,
            default: true
        },
        SnippedShowLauncherIcon: {
            type: Boolean,
            required: false,
            default: true
        },
        // ── Panel height (S1-P2) ──
        SnippedPanelHeightMode: {
            type: String,
            required: false,
            default: 'default'
        },
        SnippedPanelHeight: {
            type: [Number, String],
            required: false,
            default: null
        },
        // ── Auxiliary (not a theme field) ──
        botName: {
            type: String,
            required: false,
            default: 'Chatbot'
        }
    },
    data() {
        return {
            logoRemovebg: logoRemovebg,
            versioning: version
        };
    },
    computed: {
        dialogHeaderStyle() {
            const baseColor = this.normalizeHexColor(this.SnippedHeaderColorTheme, '#C32E0E');
            const endColor = this.lightenColor(baseColor);

            return {
                background: `linear-gradient(90deg, ${baseColor} 0%, ${endColor} 100%)`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            };
        },
        loginGradient() {
            const baseColor = this.normalizeHexColor(this.SnippedHeaderColorTheme, '#C32E0E');
            const endColor = this.lightenColor(baseColor);

            return `linear-gradient(90deg, ${baseColor} 0%, ${endColor} 100%)`;
        },
        userMessageStyle() {
            const raw = typeof this.SnippedColorThemeChat === 'string' ? this.SnippedColorThemeChat.trim() : '';
            const background = raw !== ''
                ? `${this.normalizeHexColor(raw, '#C32E0E')}1A`
                : 'rgba(195, 46, 14, 0.10)';

            return {
                background: background,
                color: this.normalizeHexColor(this.SnippedFontColorTheme, '#FFFFFF'),
            };
        },
        // ── Bot avatar (single SnippedIcon field; img vs mdi derived from URL-like value) ──
        resolvedSnippedIcon() {
            return typeof this.SnippedIcon === 'string' ? this.SnippedIcon.trim() : '';
        },
        shouldUseSnippedAvatarImage() {
            return this.isUrlLikeIcon(this.resolvedSnippedIcon);
        },
        resolvedSnippedIconImage() {
            return this.shouldUseSnippedAvatarImage ? this.resolvedSnippedIcon : '';
        },
        resolvedSnippedIconName() {
            return this.resolvedSnippedIcon !== '' && !this.shouldUseSnippedAvatarImage
                ? this.resolvedSnippedIcon
                : 'mdi-robot-outline';
        },
        resolvedSnippedIconColor() {
            return this.normalizeHexColor(this.SnippedIconColor, '#000000');
        },
        // ── R2: bot bubble · mirror userMessageStyle so both bubbles read equally soft ──
        botMessageStyle() {
            const base = this.normalizeHexColor(this.SnippedBotBubbleColor, '#71717A');
            return {
                background: `${base}1A`,
                border: `1px solid ${base}33`,
                color: this.normalizeHexColor(this.SnippedBotFontColor, '#71717A'),
            };
        },
        // ── R2: send button · empty color falls back to the chat theme colour ──
        sendButtonBaseColor() {
            const raw = typeof this.SnippedSendButtonColor === 'string' ? this.SnippedSendButtonColor.trim() : '';
            return raw !== ''
                ? this.normalizeHexColor(raw, '#C32E0E')
                : this.normalizeHexColor(this.SnippedColorThemeChat, '#C32E0E');
        },
        resolvedSendButtonVariant() {
            const v = typeof this.SnippedSendButtonVariant === 'string' ? this.SnippedSendButtonVariant.trim() : '';
            return v === 'secondary' || v === 'outline' ? v : 'default';
        },
        sendButtonSurfaceStyle() {
            const base = this.sendButtonBaseColor;
            if (this.resolvedSendButtonVariant === 'secondary') {
                return { background: `${base}1A`, border: 'none' };
            }
            if (this.resolvedSendButtonVariant === 'outline') {
                return { background: '#FFFFFF', border: `1.5px solid ${base}` };
            }
            return { background: base, border: 'none' };
        },
        // Default = solid fill so the glyph must invert; the tinted/outline variants keep it coloured.
        sendButtonForeground() {
            return this.resolvedSendButtonVariant === 'default' ? '#FFFFFF' : this.sendButtonBaseColor;
        },
        // The glyph is an SVG mask, so its colour comes from background-color.
        sendGlyphStyle() {
            return { backgroundColor: this.sendButtonForeground };
        },
        // ── R2: visibility toggles (null/undefined = show) ──
        showHeaderSubtitleResolved() {
            return this.SnippedShowHeaderSubtitle !== false;
        },
        showVersionResolved() {
            return this.SnippedShowVersion !== false;
        },
        showCharCounterResolved() {
            return this.SnippedShowCharCounter !== false;
        },
        showSnippedIconResolved() {
            return this.SnippedShowSnippedIcon !== false;
        },
        showLauncherIconResolved() {
            return this.SnippedShowLauncherIcon !== false;
        },
        // ── Panel ──
        hasHeaderSubtitle() {
            return typeof this.SnippedHeaderSubtitle === 'string' && this.SnippedHeaderSubtitle.trim() !== '';
        },
        hasDisclaimerText() {
            return typeof this.SnippedDisclaimerText === 'string' && this.SnippedDisclaimerText.trim() !== '';
        },
        // Subtitle renders only when there is text AND the toggle is on.
        showsHeaderSubtitle() {
            return this.hasHeaderSubtitle && this.showHeaderSubtitleResolved;
        },
        showBotNameResolved() {
            return this.SnippedShowBotName === true;
        },
        // [D3] show unless explicitly false (null/undefined = show) — mirror Snippet.vue `!== false`
        showModelTopicBarResolved() {
            return this.SnippedShowModelTopicBar !== false;
        },
        // [D20] panel border · ว่าง = ไม่มีขอบ
        panelBorderStyle() {
            const c = typeof this.SnippedPanelBorderColor === 'string' ? this.SnippedPanelBorderColor.trim() : '';
            return c === '' ? { border: 'none' } : { border: `1px solid ${this.normalizeHexColor(c, '#E4E4E7')}` };
        },
        // [S1-P2] panel height — same resolution rule as ChatFrameworkSnippet.js (cannot import: loader lives in public/)
        customPanelHeightPx() {
            const raw = this.SnippedPanelHeight;
            if (raw === null || raw === undefined || `${raw}`.trim() === '') {
                return null;
            }
            const n = Number(raw);
            return Number.isInteger(n) && n >= 300 && n <= 1000 ? n : null;
        },
        resolvedPanelHeightCss() {
            if (this.SnippedPanelHeightMode === 'full') {
                return 'calc(100vh - 330px)';
            }
            if (this.SnippedPanelHeightMode === 'custom' && this.customPanelHeightPx !== null) {
                return `${this.customPanelHeightPx}px`;
            }
            return '400px';
        },
        panelHeightPreviewHint() {
            if (this.SnippedPanelHeightMode === 'full') {
                return this.$t('_PanelHeightPreviewFull');
            }
            if (this.SnippedPanelHeightMode === 'custom') {
                const px = this.customPanelHeightPx;
                if (px === null) {
                    return this.$t('_PanelHeightPreviewInvalid');
                }
                const frameMax = typeof window !== 'undefined' ? window.innerHeight - 330 : Number.POSITIVE_INFINITY;
                const clamped = px > frameMax ? ` ${this.$t('_PanelHeightPreviewClamped')}` : '';
                return `${this.$t('_PanelHeightPreviewPx', { px })}${clamped}`;
            }
            return this.$t('_PanelHeightPreviewPx', { px: 400 });
        },
        // ── Teaser ──
        teaserEnabledResolved() {
            return this.SnippedTeaserEnabled === true;
        },
        teaserBubbleBackground() {
            return this.normalizeHexColor(this.SnippedTeaserBgColor, '#FFFFFF');
        },
        teaserBubbleForeground() {
            return this.normalizeHexColor(this.SnippedTeaserTextColor, '#3F3F46');
        },
        // ── Launcher ──
        // [D6] pill only when shape=pill AND text present (else fallback circle)
        isPill() {
            const text = typeof this.SnippedLauncherText === 'string' ? this.SnippedLauncherText.trim() : '';
            return this.SnippedLauncherShape === 'pill' && text !== '';
        },
        launcherBaseColor() {
            const explicit = typeof this.SnippedLauncherBgColor === 'string' ? this.SnippedLauncherBgColor.trim() : '';
            const source = explicit !== '' ? explicit : this.SnippedHeaderColorTheme;
            return this.normalizeHexColor(source, '#C32E0E');
        },
        launcherTextColorResolved() {
            return this.normalizeHexColor(this.SnippedLauncherTextColor, '#FFFFFF');
        },
        // [D17] variant ตัดสินทั้ง พื้น / เส้นขอบ / สีตัวอักษร+ไอคอน — ต้องตรงกับ ChatFrameworkSnippet.js
        resolvedLauncherVariant() {
            return ['default', 'secondary', 'outline'].includes(this.SnippedLauncherVariant) ? this.SnippedLauncherVariant : 'default';
        },
        // สีตัวอักษร+ไอคอน: default ใช้ Text Color · secondary/outline ใช้ Background Color
        launcherForeground() {
            return this.resolvedLauncherVariant === 'default' ? this.launcherTextColorResolved : this.launcherBaseColor;
        },
        // circle + รูปที่อัปโหลด → รูปกินเต็มปุ่ม ไม่มีพื้น — ต้องตรงกับ ChatFrameworkSnippet.js (isLauncherImageFull)
        // อิง !isPill (รูปที่เรนเดอร์จริง) ไม่ใช่ shape ดิบ → pill ที่ text ว่างซึ่ง fallback เป็นวงกลม ได้ผลเหมือนกัน
        isLauncherImageFull() {
            return !this.isPill && this.showLauncherIconResolved && this.shouldUseLauncherIconImage;
        },
        launcherSurfaceStyle() {
            const base = this.launcherBaseColor;
            // รูปเต็มปุ่ม → ไม่มีพื้น/เส้นขอบ variant ไม่มีผล (เงายังอยู่ที่ CSS class)
            if (this.isLauncherImageFull) {
                return { background: 'transparent', border: 'none' };
            }
            if (this.resolvedLauncherVariant === 'secondary') {
                return { background: `${base}1A`, color: base, border: 'none' };
            }
            if (this.resolvedLauncherVariant === 'outline') {
                return { background: '#FFFFFF', color: base, border: `2px solid ${base}` };
            }
            return { background: base, color: this.launcherTextColorResolved, border: 'none' };
        },
        // Launcher icon — img when IsImgSnippedLauncherIcon true + value present, else mdi (fallback robot)
        resolvedLauncherIcon() {
            return typeof this.SnippedLauncherIcon === 'string' ? this.SnippedLauncherIcon.trim() : '';
        },
        shouldUseLauncherIconImage() {
            return this.IsImgSnippedLauncherIcon === true && this.resolvedLauncherIcon !== '';
        },
        resolvedLauncherIconImage() {
            return this.shouldUseLauncherIconImage ? this.resolvedLauncherIcon : '';
        },
        resolvedLauncherIconName() {
            return !this.shouldUseLauncherIconImage && this.resolvedLauncherIcon !== ''
                ? this.resolvedLauncherIcon
                : 'mdi-robot-outline';
        },
        // Position/Offset hint (values apply on the live widget, not in this fixed-corner preview)
        launcherPositionHint() {
            const pos = typeof this.SnippedLauncherPosition === 'string' && this.SnippedLauncherPosition.trim() !== ''
                ? this.SnippedLauncherPosition.trim()
                : 'bottom-right';
            const hasOffset = this.isPresent(this.SnippedLauncherOffsetX) || this.isPresent(this.SnippedLauncherOffsetY);
            const offsetX = this.isPresent(this.SnippedLauncherOffsetX) ? this.SnippedLauncherOffsetX : 0;
            const offsetY = this.isPresent(this.SnippedLauncherOffsetY) ? this.SnippedLauncherOffsetY : 0;
            const offsetPart = hasOffset ? ` · offset (${offsetX}, ${offsetY})px` : '';
            return `ตำแหน่งจริงบนเว็บ: ${pos}${offsetPart} — พรีวิวนี้แสดงมุมล่างคงที่`;
        },
    },
    methods: {
        isPresent(value) {
            return value !== null && value !== undefined && `${value}`.trim() !== '';
        },
        isUrlLikeIcon(value) {
            if (typeof value !== 'string') {
                return false;
            }

            const normalizedValue = value.trim();
            return normalizedValue.startsWith('http://')
                || normalizedValue.startsWith('https://')
                || normalizedValue.startsWith('data:')
                || normalizedValue.startsWith('blob:');
        },
        normalizeHexColor(color, fallback) {
            const normalizedColor = typeof color === 'string' ? color.trim() : '';
            const colorWithHash = normalizedColor.startsWith('#') ? normalizedColor : `#${normalizedColor}`;

            return /^#[0-9A-Fa-f]{6}$/.test(colorWithHash) ? colorWithHash : fallback;
        },
        lightenColor(color) {
            const normalizedColor = this.normalizeHexColor(color, '#C32E0E');

            let hex = normalizedColor.replace('#', '');
            let r = Number.parseInt(hex.substring(0, 2), 16);
            let g = Number.parseInt(hex.substring(2, 4), 16);
            let b = Number.parseInt(hex.substring(4, 6), 16);

            r = Math.min(255, r + 50);
            g = Math.min(255, g + 50);
            b = Math.min(255, b + 50);

            return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
        }
    }
};
</script>
<style scoped>
    .dialog-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
    min-height: 300px;
    max-height: calc(100vh - 330px);
    width: min(100%, 400px);
  background: white;
  box-shadow: none;
  border-radius: 12px;
  border: 1px solid #E4E4E7;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-radius: 12px 12px 0 0;
}

/* วงกลม — ต้องตรงกับ header logo ใน ChatFrameworkSnippet.js (36px) ย่อสัดส่วนลงให้พอดี preview
   พื้นหลังมาจาก :style — ขาวเมื่ออัปโหลดเอง · โปร่งเมื่อใช้ default (โลโก้ default เป็นสีขาว จะกลืนพื้นขาว) */
.dialog-logo {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        object-fit: cover;
}

.dialog-subheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: white;
}

.dialog-chat-area {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background: white;
}

.dialog-footer {
  padding: 8px;
  background: white;
}

.user-message {
  background: rgba(195, 46, 14, 0.10);
  color: #18181B;
  padding: 6px 10px;
  border-radius: 18px 2px 18px 18px;
  font-size: 10px;
  max-width: 80%;
  word-wrap: break-word;
}

/* background / border / color come from :style="botMessageStyle" (SnippedBotBubbleColor + SnippedBotFontColor) */
.gpt-message {
  padding: 6px 10px;
  border-radius: 2px 18px 18px 18px;
  font-size: 10px;
  max-width: 100%;
  word-wrap: break-word;
}

/* Composer — เส้นขอบ/เงาอยู่ที่กรอบนี้ (mirror .chat-input-container ของ Snippet.vue)
   ตัวเลขในคอมเมนต์คือค่าของจริงใน Snippet.vue ที่ย่อสเกลลงมาให้พอดี preview */
.preview-composer {
  display: flex;
  align-items: flex-end;
  gap: 3px; /* ของจริง 4px */
  min-height: 26px; /* ของจริง 40px */
  padding: 3px 5px; /* ของจริง 5px 8px */
  background-color: #ffffff;
  border: 1px solid #c9c9c9; /* 1px ย่อไม่ได้ */
  border-radius: 11px; /* ของจริง 16px */
  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.06); /* ของจริง 0 4px 22px */
  transition: box-shadow 0.2s ease;
}

.preview-composer:focus-within {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
}

/* ปุ่ม send เป็น flex sibling นอก textarea (mirror .snippet-send-actions) → ข้อความไม่ลอดใต้ปุ่ม */
.preview-send-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 2px; /* ของจริง 3px */
}

/* พื้น/เส้นขอบมาจาก :style="sendButtonSurfaceStyle" */
.preview-send-btn {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  pointer-events: none;
}

/* ลูกศรเป็น mask → สีมาจาก background-color ใน sendGlyphStyle */
.preview-send-glyph {
  width: 9px;
  height: 9px;
  -webkit-mask: url('/Snippet/snippet-send.svg') no-repeat center / contain;
  mask: url('/Snippet/snippet-send.svg') no-repeat center / contain;
}

/* ฟอง "กำลังพิมพ์" — ล้อ .bot-thinking-pill ของ Snippet.vue แต่ย่อขนาดให้เข้ากับ preview */
.bot-preview-typing {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 14px;
  background: #F4F4F5;
  /* #52525B: darker than #71717A so the tiny 9px "typing…" text meets WCAG AA contrast on #F4F4F5 */
  color: #52525B;
  font-size: 9px;
  overflow: hidden;
}

.bot-preview-typing-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bot-preview-typing-dots {
  flex: 0 0 auto;
  letter-spacing: 1px;
}

.bot-preview-row {
    gap: 6px;
}

.bot-preview-avatar-shell {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.bot-preview-avatar {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: inherit;
    object-fit: cover;
}

.bot-preview-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: calc(100% - 27px);
}

.bot-preview-time {
    margin-top: 2px;
    font-size: 8px;
    color: #71717A;
}

.dialog_text_area {
  flex: 1;
  min-width: 0;
  border-radius: 8px !important;
  /* [KNOB A] ของจริง 24px · ต่ำกว่า floor ทั้งคู่ → ความสูงจริงมาจาก floor (ความสัมพันธ์เดียวกับของจริง) */
  --v-input-control-height: 16px;
}

/* [KNOB B] padding บน/ล่าง = จัด center ข้อความ 1 บรรทัด (textarea ไม่ center ด้วย flex → ต้องพึ่ง padding-top)
   ⚠️ ห้ามตั้ง 0 ทั้งคู่ — ข้อความจะเด้งติดขอบบน · ต้องแก้ที่ "ตัวแปร" ไม่ใช่ property (VTextarea.js อ่านตัวแปรไปคิด maxHeight) */
.dialog_text_area :deep(.v-field) {
  padding: 0 3px; /* ของจริง 0 4px */
  border-radius: 10px !important; /* ของจริง 15px */
  --v-field-padding-top: 0px;
  --v-input-padding-top: 3px; /* ของจริง 5px */
  --v-field-padding-bottom: 3px; /* ของจริง 5px → 1 บรรทัด = 16 + 3 + 3 */
}

/* CAP 2 บรรทัด — ต้อง clamp ที่ control-height (max-height ใช้ไม่ได้: min-height ของ VField ชนะเสมอ)
   line-height = ratio 1.5 × font 10px = 15px → 2 บรรทัด ≈ 15×2 + 6 = 36px (ผ่าน) · 3 บรรทัด ≈ 51px (ตัน) */
.dialog_text_area :deep(.v-field__field) {
  --v-input-control-height: min(var(--v-textarea-control-height), 43px) !important;
}

/* ซ่อน outline ของ Vuetify — เส้นที่เห็นคือ border ของ .preview-composer (เหมือนของจริง) ไม่งั้นได้เส้น 2 ชั้น */
.dialog_text_area :deep(.v-field__outline) {
  color: transparent !important;
}

.dialog_text_area :deep(.v-field__outline__start),
.dialog_text_area :deep(.v-field__outline__end),
.dialog_text_area :deep(.v-field__outline__notch) {
  border-color: transparent !important;
}

.dialog_text_area:focus-within :deep(.v-field__outline__start),
.dialog_text_area:focus-within :deep(.v-field__outline__end),
.dialog_text_area:focus-within :deep(.v-field__outline__notch) {
  border-color: var(--v-theme-primary) !important;
  opacity: 0.3;
}

/* ปิด mask fade ของ VTextarea ไม่งั้นบรรทัดบนโดนเฟด/ตัดบน Chrome
   ⚠️ ห้าม override padding-top/bottom ที่นี่ — ให้แก้ที่ตัวแปรใน .v-field (ไม่งั้น math ของ auto-grow เพี้ยน) */
.dialog_text_area :deep(.v-field__input) {
  -webkit-mask-image: none !important;
  mask-image: none !important;
  padding-inline: 0 !important;
  font-size: 10px;
}

/* Login button: gradient border + gradient text, keep outlined rounded design */
.login-gradient-btn {
  border: 1px solid transparent !important;
  border-radius: 8px;
  text-transform: none;
  background-image: linear-gradient(#fff, #fff), var(--login-grad);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

.login-gradient-btn :deep(.v-btn__content) {
  background: var(--login-grad);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* ── Snippet preview extension (S1-P1): header name/subtitle · disclaimer · teaser · launcher ── */
.snippet-preview-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.dialog-header-left {
  min-width: 0;
  gap: 8px;
  flex: 1;
}

.dialog-header-text {
  min-width: 0;
  color: #FFFFFF;
  line-height: 1.2;
}

.dialog-bot-name {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* [D8] subtitle clamp 2 บรรทัด + overflow-wrap: anywhere (ไทยไม่มีเว้นวรรค) */
.dialog-bot-subtitle {
  font-size: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.dialog-disclaimer {
  margin-top: 4px;
  font-size: 8px;
  color: #71717A;
  text-align: center;
  overflow-wrap: anywhere;
}

.snippet-teaser-preview {
  display: flex;
  justify-content: flex-end;
  width: min(100%, 400px);
  margin-bottom: 6px;
}

.snippet-teaser-bubble {
  position: relative;
  max-width: 200px;
  padding: 8px 22px 8px 10px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  font-size: 9px;
  color: #3f3f46;
  line-height: 1.35;
}

/* หางชี้ลงไปที่ปุ่ม launcher (ชิดขวาเหมือน launcher) */
.snippet-teaser-bubble::after {
  content: '';
  position: absolute;
  right: 22px;
  bottom: -5px;
  width: 10px;
  height: 10px;
  background: #ffffff;
  transform: rotate(45deg);
  box-shadow: rgba(99, 99, 99, 0.2) 2px 2px 4px -2px;
}

.snippet-teaser-close {
  position: absolute;
  top: 2px;
  right: 4px;
  border: 0;
  background: transparent;
  color: #a1a1aa;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}

.snippet-teaser-text {
  display: block;
  overflow-wrap: anywhere;
}

.snippet-launcher-preview {
  display: flex;
  justify-content: flex-end;
  width: min(100%, 400px);
}

.snippet-launcher-circle {
  width: 48px;
  height: 48px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

/* [D7] pill: max-width + nowrap + ellipsis (overflow กันที่ render ไม่ใช่ input) */
.snippet-launcher-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 999px;
  max-width: min(280px, calc(100% - 20px));
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  font-size: 11px;
  font-weight: 500;
}

.snippet-launcher-pill-icon {
  display: inline-flex;
  align-items: center;
}

.snippet-launcher-pill-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.snippet-launcher-icon-img {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  object-fit: cover;
}

/* circle + รูป: รูปเต็มปุ่ม (พื้น/เส้นขอบถอดที่ launcherSurfaceStyle · เงาคงไว้ที่ .snippet-launcher-circle)
   overflow: hidden กันมุมรูปโผล่นอกวงกลม · ของจริงปุ่ม 60px preview 48px → ใช้ 100% ให้ผลตรงกันทั้งคู่ */
.snippet-launcher-circle--image {
  overflow: hidden;
}

.snippet-launcher-icon-img--full {
  width: 100%;
  height: 100%;
}

.snippet-launcher-hint {
  width: min(100%, 400px);
  text-align: center;
  font-size: 8px;
  color: #a1a1aa;
  overflow-wrap: anywhere;
}
</style>
